// @flow

import _ from 'lodash';

import hardcodedZapKits from './hardcodedZapKits.json';
import { isProduction } from '@zapier/common-utils';

// also strip version off, because live selected api is different from local
const pickNodeStepsFields = steps =>
  steps.map(step => {
    step = _.pick(step, ['selected_api', 'type_of', 'action']);
    if (step && step.selected_api.indexOf('@') !== -1) {
      step.selected_api = _.split(step.selected_api, '@')[0];
    }
    return step;
  });

export const searchInstantHardcodedTemplate = (
  hardcodedTemplates: Array<any>,
  dynamicZapTemplate: Object
) => {
  const idMatchedTemplate = _.find(hardcodedTemplates, {
    id: Number(dynamicZapTemplate.id),
  });
  if (isProduction() && dynamicZapTemplate.id) {
    return idMatchedTemplate;
  } else {
    return (
      idMatchedTemplate ||
      _.find(hardcodedTemplates, hardcodedTemplate => {
        // pick out the selected_api, type_of, action steps and compare them
        const hardcodedSteps = pickNodeStepsFields(
          hardcodedTemplate.steps || []
        );
        const dynamicSteps = pickNodeStepsFields(
          _.filter(dynamicZapTemplate.steps, step =>
            Boolean(step.selected_api && step.type_of && step.action)
          )
        );
        return _.isEqual(hardcodedSteps, dynamicSteps);
      })
    );
  }
};

const getInstantHardcodedTemplate = (dynamicZapTemplate: Object) => {
  return searchInstantHardcodedTemplate(
    hardcodedZapKits[1].zap_templates, // these are the only "guaranteed" instant zaps
    dynamicZapTemplate
  );
};

export default getInstantHardcodedTemplate;
